import { render } from "./InPageNav.vue?vue&type=template&id=3ae04f5a"
import script from "./InPageNav.vue?vue&type=script&lang=js"
export * from "./InPageNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__